
import React from 'react';
import './StackedProgressBar.css';

function StackedProgressBar({ title, masteredPercent, inProgressPercent, flaggedPercent, onClick, isActive }) {
  const mastered = masteredPercent || 0;
  const inProgress = inProgressPercent || 0;
  const flagged = flaggedPercent || 0;
  const notStartedPercent = 100 - mastered - inProgress - flagged;

  return (
    <div className={`progress-bar-container ${onClick ? 'clickable' : ''} ${isActive ? 'active' : ''}`} onClick={onClick}>
      {title && <span className="progress-bar-title">{title}</span>}
      <div className="progress-bar">
        {mastered > 0 && <div 
          className="progress-segment mastered" 
          style={{ width: `${mastered}%` }}
        >
          {Math.round(mastered) > 10 && `${Math.round(mastered)}%`}
        </div>}
        {inProgress > 0 && <div 
          className="progress-segment in-progress" 
          style={{ width: `${inProgress}%` }}
        >
          {Math.round(inProgress) > 10 && `${Math.round(inProgress)}%`}
        </div>}
        {flagged > 0 && <div 
          className="progress-segment flagged" 
          style={{ width: `${flagged}%` }}
        >
          {Math.round(flagged) > 10 && `${Math.round(flagged)}%`}
        </div>}
        <div 
          className="progress-segment not-started" 
          style={{ width: `${notStartedPercent}%` }}
        >
        </div>
      </div>
    </div>
  );
}

export default StackedProgressBar;